module.exports = __webpack_public_path__ + "SourceSansPro-Light.cd64a82137fc386c3856.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-Light.ttf
// module id = ../../../../../src/assets/customfonts/SourceSansPro-Light.ttf
// module chunks = styles